import React from 'react'
import { BasePage as CngBasePage, useTranslation } from 'cng-web-lib'

import Namespace from 'src/constants/locale/Namespace'
import CalistaAdvisoryKey from 'src/constants/locale/key/CalistaAdvisory'
import BreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ReportPage from './ReportPage'

function ModuleTitle() {
    const { translate } = useTranslation(Namespace.CALISTA_ADVISORY)
    return translate(Namespace.CALISTA_ADVISORY, CalistaAdvisoryKey.SUB_MODULE_TITLE.CIA_ADMIN_REPORT)
}

function WrappedReportPage(props) {
    const breadcrumbNameMap = BreadcrumbNameMap()
    return (
        <CngBasePage
            moduleTitle={ModuleTitle()}
            renderPage={(showSnackbar) => (
                <ReportPage showNotification={showSnackbar} {...props} />
            )}
            extraCngBreadcrumbNameMap={breadcrumbNameMap}
        />
    )
}

export {
    WrappedReportPage as ReportPage
}
